<template>
  <div class="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
    <div class="flex items-center gap-2 text-sm font-semibold text-gray-700">
      <FunnelIcon class="w-4 h-4" />
      {{ title }}
    </div>
    <div class="mt-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { FunnelIcon } from '@heroicons/vue/24/outline'

interface Props {
  title?: string
}

withDefaults(defineProps<Props>(), {
  title: '필터'
})
</script>
